// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store'

// For LocalStorage Handle
import VueLocalStorage from 'vue-localstorage'


// Services
Vue.config.productionTip = false
Vue.use(VueLocalStorage)
Vue.config.debug = true;
Vue.config.devtools = true; 

export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js